import { render, staticRenderFns } from "./EditAdmissionComponent.vue?vue&type=template&id=470fbbf7&scoped=true&"
import script from "./EditAdmissionComponent.vue?vue&type=script&lang=js&"
export * from "./EditAdmissionComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditAdmissionComponent.vue?vue&type=style&index=0&id=470fbbf7&prod&lang=scss&"
import style1 from "./EditAdmissionComponent.vue?vue&type=style&index=1&id=470fbbf7&prod&scoped=true&lang=css&"
import style2 from "./EditAdmissionComponent.vue?vue&type=style&index=2&id=470fbbf7&prod&lang=scss&"
import style3 from "./EditAdmissionComponent.vue?vue&type=style&index=3&id=470fbbf7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470fbbf7",
  null
  
)

export default component.exports